export default __webpack_public_path__ + "static/media/section03.3a577a72.jpg";